export type MapTravelMode = 'drive' | 'walk' | 'transit';

const toGoogleTravelMode = (mode: MapTravelMode): string => {
  switch (mode) {
    case 'walk':
      return 'WALKING';
    case 'transit':
      return 'TRANSIT';
    default:
      return 'DRIVING';
  }
};

export const normalizeMapTravelMode = (mode?: string | null): MapTravelMode => {
  if (mode === 'walk' || mode === 'transit') return mode;
  return 'drive';
};

export const getLegTravelMode = (
  leg?: { mode?: string; chosenMode?: string } | null,
  fallback: MapTravelMode = 'drive',
): MapTravelMode => normalizeMapTravelMode(leg?.chosenMode || leg?.mode || fallback);

export const fetchDirectionsPath = async (
  origin: { lat: number; lng: number },
  destination: { lat: number; lng: number },
  mode: MapTravelMode,
): Promise<Array<{ lat: number; lng: number }> | null> => {
  if (!window.google?.maps?.DirectionsService) {
    return null;
  }

  const travelMode = window.google.maps.TravelMode?.[toGoogleTravelMode(mode)]
    || toGoogleTravelMode(mode);

  return new Promise((resolve) => {
    const service = new window.google.maps.DirectionsService();
    service.route(
      {
        origin,
        destination,
        travelMode,
      },
      (result: { routes?: Array<{ overview_path?: Array<{ lat: () => number; lng: () => number }> }> } | null, status: string) => {
        const path = result?.routes?.[0]?.overview_path;
        if (status !== 'OK' || !path?.length) {
          resolve(null);
          return;
        }

        resolve(path.map((point) => ({ lat: point.lat(), lng: point.lng() })));
      },
    );
  });
};
